/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBindSection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 3v2h2V3zm3 0v2h2V3zm4 0v2h2V3zm4 0v2h2V3zm4 0v2h2V3zm3 0v2h2V3zM2 7v2h2V7zm5 0H6v10h6V7h-1zm1 8V9h2v6zm12-6h2V7h-2zM2 11v2h2v-2zm0 4v2h2v-2zm0 4v2h2v-2zm3 0v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2zm6.75-8-.834 3.75L21.833 16l-5 5 2.083-4.167L16 15.583z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBindSection as BindSection };
